// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"SuspenseWithFlag_fallbackContainer__e8hFw","childrenContainer":"SuspenseWithFlag_childrenContainer__du+uo"};